import React from "react";
import { useProfile } from "@/hooks/useProfile";
import Swal from "sweetalert2"; // Import SweetAlert2

export const Button = ({ children, onClick, type = "button" }) => {
    const { profileCompleteness } = useProfile();

    // Handle button click
    const handleClick = (e) => {
        if (profileCompleteness !== 100) {
            // Show SweetAlert2 message if profile is incomplete
            Swal.fire({
                title: "Profile Incomplete",
                text: "Please complete your profile to proceed.",
                icon: "warning",
                confirmButtonText: "OK",
            });
        } else {
            // Call the original onClick handler if profile is complete
            onClick(e);
        }
    };

    return (
        <div className="flex items-center justify-end w-full p-4 bg-white">
            <button
                type={type}
                onClick={handleClick} // Use the custom handleClick function
                className={`border border-[#3b4249] font-medium ${profileCompleteness === 100 ? "bg-[#8ec639]" : "bg-gray-400 cursor-not-allowed"
                    } rounded-md text-white px-8 py-3 mt-4`}
                disabled={profileCompleteness !== 100} // Disable button if profile is incomplete
            >
                {children}
            </button>
        </div>
    );
};